// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__wa3wK","Outlined":"Button_Outlined__w+N8-","TextButton":"Button_TextButton__x0JQ6"};